import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Grid4x4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"grid_4x4"}/>
}
